export var PayoutAccountsTypes;
(function (PayoutAccountsTypes) {
    let PayoutComponents;
    (function (PayoutComponents) {
        PayoutComponents["ManagePayouts"] = "ManagePayouts";
        PayoutComponents["SelectPayout"] = "SelectPayout";
        PayoutComponents["FormSelect"] = "FormSelect";
        PayoutComponents["DeleteConfirmation"] = "DeleteConfirmation";
    })(PayoutComponents = PayoutAccountsTypes.PayoutComponents || (PayoutAccountsTypes.PayoutComponents = {}));
    let PayoutFlow;
    (function (PayoutFlow) {
        PayoutFlow["Create"] = "create";
        PayoutFlow["Update"] = "update";
    })(PayoutFlow = PayoutAccountsTypes.PayoutFlow || (PayoutAccountsTypes.PayoutFlow = {}));
})(PayoutAccountsTypes || (PayoutAccountsTypes = {}));
